Auth = require 'db/auth'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
l = require 'lib/localize'
Member = undefined
queueRequire -> Member = require 'models/member'
MemberAccountView = undefined
queueRequire -> MemberAccountView = require 'views/member/member-account-view'
MemberBillingView = undefined
queueRequire -> MemberBillingView = require 'views/member/member-billing-view'
MemberHomeView = undefined
queueRequire -> MemberHomeView = require 'views/member/member-home-view'
MemberCardsView = undefined
queueRequire -> MemberCardsView = require 'views/member/member-cards-view'
MemberNotificationsView = undefined
queueRequire -> MemberNotificationsView = require 'views/member/member-notifications-view'
MemberProfileView = undefined
queueRequire -> MemberProfileView = require 'views/member/member-profile-view'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
updateTimezone = require 'lib/update-timezone'
$ = require 'jquery'
log = require 'debug/log'
_ = require 'underscore'
assert = require 'lib/assert'
ApiError = require 'network/api-error'
getExperiment = require 'lib/experiments/simple-test'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'
Util = require 'lib/util'
Storage = require 'lib/storage'

# Variables used to determine if we should pretend the user is new, for testing
# purposes
simulateNewUser = null

# keeps track if the browser forward or back buttons are used
browserNav = false
$(window).on 'popstate', ->
  browserNav = true

module.exports =
  routes: [
    ['', 'memberHomeView']
    [':orgname/home', 'memberHomeView']
    [':username/boards', 'memberAllBoardsView']
    [':username/cards', 'memberCardsView']
    [':username/cards/:orgname', 'memberCardsView']
    [':username/notifications', 'memberNotificationsView']
  ]

  displayMemberPage: (settings) ->
    { username, loadFn, viewClass, getLocation, bodyClass, product, orgname, titleKey, superHomeAllBoardsTab } = settings
    username ?= Auth.myUsername()

    log('controller', ['memberHomeView'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', loadFn, username
      .then (member) =>
        if Auth.me() && Auth.isLoggedIn() && !Auth.confirmed() &&
            getExperiment('confirmDuringSignup').get('enabled')
          return @navigate '/confirm-email', { trigger: true }

        memberHasNoBoards = member.boardList.length == 0 ||
          (member.boardList.length == 1 && member.boardList.models[0].isWelcomeBoard())

        simulateNewUser ?= $.cookie('simulateNewUser')

        isNewUser = simulateNewUser ||
          Util.idToDate(Auth.myId()) > Util.dateBefore({ days: 7 })

        if viewClass == MemberHomeView && isNewUser && memberHasNoBoards && !Auth.me().isDismissed('create-first-board')
          return @redirectToFirstBoard(member)

        @clearPreviousView()

        if Auth.isMe(member) && viewClass == MemberHomeView
          @setViewType("home")
        else
          @setViewType(member)

        title =
          if Auth.isMe(member) && titleKey?
            l(['page title', titleKey])
          else
            "#{member.get('fullName')} (#{member.get('username')})"

        # Do this before creating the view, in case the view has more
        # specific logic for setting the URL
        @setLocation
          title: title
          location: getLocation.call(@, member.get('username'), product)
          options:
            replace: true

        options = { product, orgname, modelCache: ModelCache, superHomeAllBoardsTab }

        memberView = @topLevelView(viewClass, member, options)
        @showHeader()
        @maybeShowFooterChrome(@getMemberBoardsUrl(member.get('username'), orgname))

        if bodyClass
          $('#classic-body').addClass(bodyClass)
        else
          $('#classic-body').addClass('body-tabbed-page')

        $('#content').html(memberView.render().el)
        @focusContent()
        memberView.getData?()

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  redirectToFirstBoard: (member) ->
    if getExperiment('madLibs').get('enabled')
      return @navigate '/create-first-board', { trigger: true }

    # Data that we'll use in the body of the POST to create the board
    initialData =
      name: l(['untitled board'])

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      defaultLists: true
    }, initialData)

    newBoard = member.boardList.create initialData, {
      requestData: requestData
      success: (board) =>
        Auth.me().dismiss('create-first-board')
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we get the board id back before we can
        # display the board
        @displayBoard({
          idBoard: board.id
          openListComposer: false
          openCardComposerInFirstList: true
        }).done()

        return
      error: =>
        @displayErrorPage()
    }

    return

  memberAllBoardsView: (username) ->
    # caught by ':username/boards' route
    # but we actually want to show the 'memberHomeView'
    # just without any organisation, to show the SH all boards tab
    @memberHomeView(null, true)

  memberHomeView: (orgname, superHomeAllBoardsTab) ->
    if !Auth.isLoggedIn()
      # Hopefully you're not being routed here if you aren't logged in and
      # the server is sending you to the home page
      return @displayErrorPage()

    ModelCache.waitFor 'Member', Auth.myId(), =>
      Storage.unset("home_#{Auth.myId()}_last_tab") # Clean up old key

      defaultTab = "/#{Auth.myUsername()}/boards"
      lastHomeTab = Storage.get("home_#{Auth.myId()}_last_tab_2") ? defaultTab
      # if there is no orgname or it's not on all boards tab then it means we are on '/'
      # in that case if there is a last home tab that isn't '/' we want to redirect to that
      if !orgname && !superHomeAllBoardsTab && lastHomeTab && lastHomeTab != '/' && !browserNav
        browserNav = false
        return @navigate lastHomeTab, { trigger: true, replace: true }
      else if browserNav
        # if navigating with browser nav buttons then we need to set the last tab
        Storage.set("home_#{Auth.myId()}_last_tab_2", window.location.pathname)

      if orgname && !@isMemberOfOrg(orgname)
        Storage.unset("home_#{Auth.myId()}_last_tab_2")
        return @navigate(defaultTab, { trigger: true, replace: true })

      browserNav = false
      # If you're logged in, always kick you to your own boards page, since you
      # can't see anyone elses
      simulateNewUser ?= $.cookie('simulateNewUser')
      opts =
        username: 'me'
        loadFn: 'loadMemberBoardsData'
        viewClass: MemberHomeView
        getLocation: (username) =>
          @getMemberBoardsUrl(username, orgname)
        titleKey: 'boards'
        orgname: orgname
        superHomeAllBoardsTab: superHomeAllBoardsTab

      @displayMemberPage(opts)
        .then(updateTimezone)
        .then(=>
          title = if typeof orgname == 'undefined'
            l(['page title', 'home'])
          else if superHomeAllBoardsTab == true
            l(['page title', 'boards'])
          else
            ModelCache.findOne('Organization', 'name', orgname)?.get('displayName')
          @title(title)
        )
        .done()

      if( simulateNewUser || Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 }))
        trackGoogleTagManager.possibleNewSignup()

  isMemberOfOrg: (orgname) ->
    orgs = ModelCache.get('Member', Auth.myId())?.getSortedOrgs()
    return orgs.find((org) => org.get('name') == orgname)

  memberNotificationsView: (username = 'me') ->
    if !Auth.isLoggedIn()
      return @displayErrorPage()

    # If you're logged in, always kick you to your own notifications page,
    # since you can't see anyone else's
    username = 'me'
    @displayMemberPage
      username: username
      loadFn: 'loadNotificationData'
      viewClass: MemberNotificationsView
      getLocation: @getMemberNotificationsUrl
      titleKey: 'notifications'
    .done()

  memberProfileView: (username = 'me') ->
    @displayMemberPage
      username: username,
      loadFn: 'loadMemberProfileData'
      viewClass: MemberProfileView
      getLocation: @getMemberProfileUrl
      titleKey: 'profile'
    .done()

  memberCardsView: (username = 'me', orgname) ->
    @displayMemberPage
      username: username
      loadFn: 'loadMemberCardsData'
      viewClass: MemberCardsView
      getLocation: (username) =>
        @getMemberCardsUrl(username, orgname)
      titleKey: 'cards'
      orgname: orgname
    .done()

  memberAccountView: (username) ->
    username = 'me'
    @displayMemberPage
      username: username
      loadFn: 'loadMemberAccountData'
      viewClass: MemberAccountView
      getLocation: @getMemberAccountUrl
      titleKey: 'settings'
    .done()

  memberBillingView: (username) ->
    username = 'me'
    @displayMemberPage
      username: username
      loadFn: 'loadMemberAccountData'
      viewClass: MemberBillingView
      getLocation: @getMemberBillingUrl
      titleKey: 'billing'
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/member-routes.coffee